import React, { useState, useEffect } from 'react';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError } from 'utils';
import i18n from 'i18n-js';
import { PARTNER_STATUS_FAAS, PARTNER_STATUS_FFB } from 'constants';

const PartnerStatusSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields = [],
  asyncErrors,
  margin = 'none',
  id,
  sharingType,
}) => {
  const [defaultValue, setDefaultValue] = useState('');

  const PARTNER_STATUS = sharingType === 'FAAS' ? PARTNER_STATUS_FAAS : PARTNER_STATUS_FFB;

  useEffect(() => {
    if (value || value === '') {
      const newVal = PARTNER_STATUS.find((status) => status === value);
      if (newVal) {
        setDefaultValue(newVal);
      } else {
        setDefaultValue('');
      }
    }
  }, [value, setDefaultValue]);

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      id={id || 'partner-status-select'}
      variant={variant}
      value={defaultValue}
      error={handleError(name, errors, touched, asyncErrors)}
      onChange={(_, val) => setFieldValue(name, val || '')}
      options={PARTNER_STATUS.filter((value) => omitFields.indexOf(value))}
      getOptionSelected={(option, value) => option === value || ''}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      getOptionLabel={(option) => (option ? i18n.t(`partners.statuses.${option}`) : '')}
    />
  );
};

export { PartnerStatusSelect };
